import { ChartSeries } from "src/components/chart/series";
import { VisualChart } from "src/gql/visuals/types";
import { chartOptionLegend } from "src/components/chart/options";
import { chartOptionOnlyPieCharts } from "src/components/chart/options";
import { leftAxisColumns } from "src/components/chart/series";
import { rightAxisColumns } from "src/components/chart/series";

export interface ChartBounds {
  xMax: number;
  yMax: number;
  width: number;
  height: number;
  legend: number;
  margin: ChartBoundsRect;
}

interface ChartBoundsRect {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export const createChartBounds = (
  visual: VisualChart,
  series: ChartSeries,
  width: number,
  height: number
): ChartBounds => {
  const onlyPiecharts = chartOptionOnlyPieCharts(visual);
  const y0s = leftAxisColumns(series);
  const y1s = rightAxisColumns(series);

  const margin = {
    top: 20,
    bottom: 40,
    left: 20,
    right: 20,
  };

  // Show the chart legend if the option is enabled
  // and if the chart width is above a certain threshold.
  const legend = chartOptionLegend(visual) && width > 400 ? 130 : 0;

  if (legend > 0) {
    margin.right += legend - 10;
  }

  if (!onlyPiecharts && y0s.length > 0) {
    margin.left += 40;
  }

  if (!onlyPiecharts && y1s.length > 0) {
    margin.right += 40;
  }

  return {
    xMax: width - margin.left - margin.right,
    yMax: height - margin.top - margin.bottom,
    width,
    height,
    margin,
    legend,
  };
};
